"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertItemsToCamelCase = exports.convertItemsToSnakeCase = void 0;
const lodash_1 = __importDefault(require("lodash"));
function convertItemsToSnakeCase(items) {
    const snakeCasedItems = [];
    for (const item of items) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const tempSnakeObj = {};
        for (const key in item) {
            const value = item[key];
            tempSnakeObj[lodash_1.default.snakeCase(key)] = value;
        }
        snakeCasedItems.push(tempSnakeObj);
    }
    return snakeCasedItems;
}
exports.convertItemsToSnakeCase = convertItemsToSnakeCase;
function convertItemsToCamelCase(items) {
    const snakeCasedItems = [];
    for (const item of items) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const tempSnakeObj = {};
        for (const key in item) {
            const value = item[key];
            tempSnakeObj[lodash_1.default.camelCase(key)] = value;
        }
        snakeCasedItems.push(tempSnakeObj);
    }
    return snakeCasedItems;
}
exports.convertItemsToCamelCase = convertItemsToCamelCase;
//# sourceMappingURL=basic.js.map